import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { StreakFreezeSimpleIcon } from '../atoms/icons/streak_freeze_simple_icon';
import { CircleCheckIcon } from '../atoms';
import { ActivityStreakMonthStatCard } from '../atoms';
export const ActivityStreakMonthStat = ({ totalCompletedDays, totalFreezeUsedDays, classObject }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(ActivityStreakMonthStatCard, { icon: React.createElement(CircleCheckIcon, { classObject: styles.checkIcon, color: Colors.Orange, fillColor: Colors.White, filled: true }), label: "\u304C\u3093\u3070\u3063\u305F\u65E5\u6570", value: totalCompletedDays }),
        React.createElement(ActivityStreakMonthStatCard, { icon: React.createElement(StreakFreezeSimpleIcon, { classObject: styles.freezeIcon }), label: "\u30D5\u30EA\u30FC\u30BA\u4F7F\u7528\u65E5\u6570", value: totalFreezeUsedDays })));
};
const styles = StyleSheet.create({
    container: {
        alignItems: 'stretch',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'row',
        gap: 8,
    },
    checkIcon: {
        height: 18,
        width: 18,
    },
    freezeIcon: {
        height: 22,
        width: 23,
    },
});
